<template>
  <v-btn color="red"
         small
         outline
         @click="destroy"
         v-if="canDelete && $auth.isDev()"
         :disabled="$auth.isCust()"
         >
         {{ $t('delete') }}
  </v-btn>
</template>

<script>
import Shipment from '@/client/shipment'

export default {
  name: 'ShipmentDeleteBtnComp',

  props: {
    shipment: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
    }
  },

  components: {
  },

  computed: {
    canDelete () {
      if (this.shipment.status === 'pending') { return true }
      if (this.shipment.status === 'error') { return true }

      return false
    }
  },

  methods: {
    async destroy () {
      if (!this.canDelete) { return }

      try {
        await Shipment.destroyById(this.shipment.id)
      } catch (err) {
        // empty
      }
      this.$emit('fetch')
    }
  },

  watch: {
  },

  async mounted () {
  }
}
</script>
